import { baseApi } from '@/shared/api'
import type {
  ShipmentItems,
  ShipmentItemsQuery,
  ShipmentList,
  ShipmentsQuery,
} from '../model/types'

export const shipmentApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    /** Отгрузки клиента за период. Период по умолчанию — 12 месяцев, его выбирает бэк. */
    getShipments: build.query<ShipmentList, ShipmentsQuery>({
      query: (params) => ({ url: '/shipments', params }),
      providesTags: [{ type: 'Shipment', id: 'LIST' }],
    }),

    /** Состав отгрузки — строки накладной. */
    getShipmentItems: build.query<ShipmentItems, { doc: string } & ShipmentItemsQuery>({
      query: ({ doc, ...params }) => ({ url: `/shipments/${encodeURIComponent(doc)}`, params }),
      providesTags: (_res, _err, { doc }) => [{ type: 'Shipment', id: doc }],
    }),
  }),
})

export const { useGetShipmentsQuery, useGetShipmentItemsQuery } = shipmentApi
